import { init } from '@atlaskit/insm';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import type { SessionDataType } from '@confluence/session-data/entry-points/SessionDataTypes';

export function initializeINSM(_sessionData: SessionDataType): void {
	init({
		getAnalyticsWebClient: getAnalyticsWebClient(),
		experiences: {
			'edit-page': { enabled: true },
			'live-edit': { enabled: true },
		},
	});
}
